/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./oauthConsent.vue?vue&type=template&id=9481068e&scoped=true"
import script from "./oauthConsent.vue?vue&type=script&lang=js"
export * from "./oauthConsent.vue?vue&type=script&lang=js"
import style0 from "./oauthConsent.vue?vue&type=style&index=0&id=9481068e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9481068e",
  null
  
)

export default component.exports